import React, { PureComponent } from "react";
import WelcomeLayout from "../../layouts/welcome";
import Teams from "../../../../api/Teams";

const FEEDBACK_CONTENT = {
  "market leader":
    "Bold, fearless, dominant, are a few words that come into mind. Keep performing at this high level and maintain your leadership. <b>#Boss</b>!",
  "market challenger":
    "Great round! You've done a great job in challenging the leader. Next round, become the leader. <b>#Soon-to-be-Boss</b>",
  "market climber":
    "Not bad! Keep climbing until you reach your full potential. <b>#Be-the-Boss</b>",
  "market warrior":
    "Good battle! You fought the good fight. Now let's go win the war. Become the leader! <b>#Be-the-Boss</b>",
  "market newbie":
    "Young Grasshopper, you have ways to go, but we will help you climb, to become a warrior to then challenge the leader. You will be a Master. <b>#Be-the-Boss</b>"
};

class TeamReportsSection1Step1 extends PureComponent {
  get left_content() {
    const team = Teams.currentTeam();
    const team_name = team ? team.name : "";
    const players = Teams.players().filter(i => "user" in i && i.user);
    const roles = {
      CEO: "CEO",
      PD: "Head of Product Management",
      PM: "Head of Product Marketing",
      OP: "Head of Operations",
      FI: "Head of Finance",
      VI: "Viewer"
    };

    return (
      <span>
        <br />
        <b>{team_name}</b>
        <br />
        {players.map(player => (
          <span key={player.id}>
            {player.user.username} - {roles[player.role]}
            <br />
          </span>
        ))}
      </span>
    );
  }

  get right_content() {
    const { rank_name } = this.props;
    const message =
      rank_name.toLowerCase() in FEEDBACK_CONTENT
        ? FEEDBACK_CONTENT[rank_name.toLowerCase()]
        : "";

    return (
      <span className="team-reports-welcome-1">
        You are
        <span className="rank-name">{rank_name}</span>
        <span dangerouslySetInnerHTML={{ __html: message }} />
      </span>
    );
  }

  render() {
    return (
      <WelcomeLayout
        title="MG Team Reports"
        left_content={this.left_content}
        right_content={this.right_content}
      />
    );
  }
}

export default TeamReportsSection1Step1;



// WEBPACK FOOTER //
// ./src/components/team-reports/steps/section-1/step-1.js